import { IIndexable } from '../model/IIndexable';
import { Phone } from '../model/Phone';

const HYPHEN = '-';

export function phoneMapping(item: IIndexable) {
  const telephone: string | undefined = item?.telephone;

  if (!telephone || telephone.trim?.().length === 0) return undefined;

  /**Si hay un guión en el número de teléfono recibido del
   * backend, entonces el número antes del guión es el
   * prefijo y el número después es el teléfono.
   */
  const split = telephone?.split?.(HYPHEN);
  const hyphenCount = split?.length ? split?.length - 1 : 0;

  if (hyphenCount === 1) {
    const prefixPart = split?.[0];
    const telephonePart = split?.[1];

    if (telephonePart?.trim?.().length === 0) return undefined;

    return new Phone(prefixPart?.trim?.().length === 0 ? undefined : prefixPart, telephonePart);
  }

  /**Otro caso: se envía el prefijo y el teléfono en dos
   * campos separados. */
  return new Phone(item?.prefix, telephone);
}
